import React from 'react';
import styles from './styles.module.scss';

type Props = {
  anchor: string;
  children: React.ReactNode;
};

// компонент необходим для компенсации наезжания шапки сайта, которая абсолютно спозиционирована и поэтому
// выпадает из потока документа
const ScrollAnchor: React.FC<Props> = ({ anchor, children}) => {
  return (
    <div>
      <div id={anchor} className={styles['scroll-offset']}/>
      {children}
    </div>
  );
};

export default ScrollAnchor;
